import * as React from "../../_snowpack/pkg/react.js";
const DetailListItem = ({label, content}) => {
  return /* @__PURE__ */ React.createElement("li", {
    className: "pb-2"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "font-bold"
  }, label), /* @__PURE__ */ React.createElement("br", null), content.length === 0 ? /* @__PURE__ */ React.createElement("p", {
    className: "pl-4 italic text-sm"
  }, "Response not available") : /* @__PURE__ */ React.createElement("p", {
    className: "pl-4"
  }, content));
};
export default DetailListItem;
